import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { ExternalLink } from "lucide-react";

export default function PdfViewerModal({ open, onOpenChange, url, title = "PDF" }) {
  if (!url) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl w-[95vw] h-[85vh] flex flex-col p-0">
        <DialogHeader className="px-6 py-4 border-b border-border flex flex-row items-center justify-between">
          <DialogTitle className="text-lg">{title}</DialogTitle>
          <a href={url} target="_blank" rel="noopener noreferrer">
            <Button variant="outline" size="sm" className="gap-1">
              <ExternalLink className="h-4 w-4" />
              Open in new tab
            </Button>
          </a>
        </DialogHeader>
        <div className="flex-1 min-h-0 p-2">
          <iframe
            src={url}
            title={title}
            className="w-full h-full rounded border border-border"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
